export default {
  area: "渑池县智慧养老",
  objectName: "",
  //url
  // hostUrl : 'http://cuiyun.dexian.ren/',
  hostUrl: 'https://mczhyl.anluoyun.cn',
  apiHttpsUrl: 'https://mczhyl.anluoyun.cn/prod-api',
  apiRequestUrl: 'https://mczhyl.anluoyun.cn/prod-api',
  apiUploadUrl: 'https://mczhyl.anluoyun.cn/prod-api/upload/uploadImage',
  apiUploadFiles: 'https://mczhyl.anluoyun.cn/prod-api/upload/uploadImage',
  apiRequestUrlOrgan: 'https://mczhyl.anluoyun.cn/prod-api/So/',
}
